import { CONTACT } from "@/lib/constants";

// Telegram SVG
export const TelegramIcon = ({ size = 22 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.247l-1.97 9.289c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12L7.127 14.4l-2.95-.924c-.64-.204-.654-.64.136-.954l11.527-4.447c.535-.194 1.003.131.722.172z"/>
  </svg>
);

// Instagram SVG
export const InstagramIcon = ({ size = 22 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

// X (Twitter) SVG
export const XIcon = ({ size = 22 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.259 5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

interface SocialIconsProps {
  className?: string;
  iconSize?: number;
}

export function SocialIcons({ className = "", iconSize = 20 }: SocialIconsProps) {
  const links = [
    {
      href: (CONTACT as any).tgChannel || "https://t.me/yo5387",
      icon: TelegramIcon,
      label: "Telegram Channel",
      // Official Telegram blue
      style: { background: "#2CA5E0" },
    },
    {
      href: (CONTACT as any).instagram || "#",
      icon: InstagramIcon,
      label: "Instagram",
      // Official Instagram gradient
      style: { background: "linear-gradient(45deg, #F58529, #DD2A7B, #8134AF)" },
    },
    {
      href: (CONTACT as any).twitter || "#",
      icon: XIcon,
      label: "X (Twitter)",
      // Official X/Twitter black
      style: { background: "#000000" },
    },
  ];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {links.map(({ href, icon: Icon, label, style }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className="flex items-center justify-center w-9 h-9 rounded-full text-white transition-opacity hover:opacity-80 shadow-md"
          style={style}
        >
          <Icon size={iconSize} />
        </a>
      ))}
    </div>
  );
}
